import {mapState, mapGetters} from 'vuex';
import {arrayToQueryParams, formatUrl} from '@teemill/common/helpers';
import Blog from '../../../classes/blog';
import {ApiError, NotFoundError} from '@teemill/common/errors';

export default {
  props: {
    /**
     * The divisions that blog should fetch data from
     */
    divisions: {
      type: Array,
    },
  },

  computed: {
    ...mapState('blog', {
      paginate: 'paginate',
      total: 'total',
      post: 'post',
      posts: 'posts',
      tag: 'tag',
      tags: 'tags',
      next: 'next',
      fetching: 'fetching',
    }),

    ...mapGetters('blog', {
      tagsPosts: 'tagsPosts',
      statePost: 'statePost',
      seoKeywords: 'seoKeywords',
      pageTitle: 'pageTitle',
      listTags: 'listTags',
    }),

    activeTag() {
      return this.$store.getters['blog/findActiveTag'](this.$route);
    },

    tagItems() {
      const activeTagName = this.$route.params.tag;

      return this.tags.map(tag => ({
        ...tag,
        disabled: tag.name === activeTagName,
        text: tag.name,
      }));
    },
  },

  methods: {
    /**
     * Fetch paginated posts from server
     */
    async fetchPaginatedPosts() {
      if (!this.divisions) {
        return [];
      }

      if (this.total === null || this.total > this.posts.length) {
        return new Promise((resolve, reject) => {
          this.$store
            .dispatch('blog/fetchPaginatedPosts', {
              divisions: this.divisions,
            })
            .then(data => resolve(data))
            .catch(err => reject(err));
        });
      }

      return [];
    },

    /**
     * Fetch a specific post from server
     *
     * @param {String} post
     *
     * @return {Promise}
     */
    fetchPost(post) {
      return fetch(
        formatUrl(
          `/omnis/v3/blog/show/?blogPost=${post}${
            this.divisions
              ? `&${arrayToQueryParams('divisions', this.divisions)}`
              : ''
          }`
        ),
        {
          credentials: 'include',
          mode: 'no-cors',
        }
      )
        .then(response => {
          if (response.ok) {
            return response.json();
          }

          if (response.status === 404) {
            throw new NotFoundError();
          }

          throw new ApiError(
            `Request to fetch a blog post failed with status ${response.status}`
          );
        })
        .then(blogPost => {
          this.$store.commit('blog/setVariable', {
            key: 'post',
            value: Blog.map(blogPost),
          });

          return blogPost;
        });
    },

    /**
     * Fetch a specific post from server
     *
     * @param {String}   post The post to fetch
     * @return {Promise}
     */
    async fetchAllPosts() {
      return new Promise(resolve => {
        this.$store
          .dispatch('blog/fetchAllPosts', {
            divisions: this.divisions,
          })
          .then(data => resolve(data));
      });
    },

    /**
     * Fetch a specific post from server
     *
     * @param {String}   post The post to fetch
     * @return {Promise}
     */
    async fetchTags() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('blog/fetchTags', {
            divisions: this.divisions,
          })
          .then(data => resolve(data))
          .catch(error => reject(error));
      });
    },

    /**
     * Fetch paginated posts from server
     */
    async fetchTaggedPosts(tag) {
      return new Promise(resolve => {
        this.$store
          .dispatch('blog/fetchTaggedPosts', {
            divisions: this.divisions,
            tag,
          })
          .then(data => resolve(data))
          .catch(({status, data}) => {
            if (status === 404) {
              this.$router.replace('/404');
            } else {
              Error(data);
            }
          });
      });
    },
  },

  created() {
    /**
     * If we have not yet fetched the tags
     */
    if (!this.tags.length && this.meta.indexPage) {
      this.fetchTags().catch(() => {
        // noop
      });
    }
  },
};
